export default {
  accepted: 'Aceptado',
  accessRequestDate: 'Fecha de solicitud de acceso',
  confirmUserWillBeSystemAdmin: 'El usuario será un administrador del sistema. ¿Continuar?',
  copyInvitationLink: 'Copiar enlace de invitación al portapapeles',
  copyInvitationLinkConfirmMessage:
    'Si el usuario invitado no ha recibido ningún correo electrónico en la dirección {{email}}, \npuede copiar el enlace de invitación al portapapeles y compartirlo con él de otras maneras.\n\n¿Copiar el enlace de invitación al portapapeles?',
  copyPasswordResetLink: '¿Copiar enlace de restablecimiento de contraseña al portapapeles?',
  copyPasswordResetLinkConfirmMessage:
    'Si el usuario ha restablecido su contraseña pero no ha recibido ningún correo electrónico en la dirección {{email}}, \npuede copiar el enlace de restablecimiento de contraseña al portapapeles y compartirlo con él de otras maneras.\n\n¿Copiar el enlace de restablecimiento de contraseña al portapapeles?',
  editSurveyUserExtraPropsForUser:
    'Editar propiedades adicionales de usuario de la encuesta para el usuario "{{userName}}"',
  inviteUser: 'Invitar',
  invitationExpiredClickToSendAgainTheInvitation: 'Invitación caducada: haga clic para enviar la invitación de nuevo',
  invitationLinkCopiedToClipboard: 'Enlace de invitación copiado en el portapapeles',
  invitedBy: 'Invitado por',
  invitedDate: 'Fecha de invitación',
  lastLogin: 'Último inicio de sesión',
  moreThan30DaysAgo: 'Hace más de 30 días',
  notAcceptedYet: 'Invitación aún no aceptada',
  passwordResetLinkCopiedToClipboard: 'Enlace de restablecimiento de contraseña copiado en el portapapeles',
  passwordResetLink: 'Enlace de restablecimiento de contraseña',
  prefs: {
    title: 'Preferencias de notificación',
    notifyOnUserAccessRequest: 'Nuevas solicitudes de acceso de usuarios',
  },
  roleInCurrentSurvey: 'Rol en la encuesta actual',
  roleInSurvey: 'Rol en la encuesta',
  filterPlaceholder: 'Filtrar por nombre o correo electrónico',
  surveyName: 'Nombre de la encuesta',
  surveyExtraProp: {
    label: 'Propiedad extra de la encuesta',
    label_other: 'Propiedades extra de la encuesta',
  },
  surveysDraft: 'Encuestas (borrador)',
  surveysPublished: 'Encuestas (publicadas)',
  userRemovedFromSurveyGoToSurveysRequired: `Has sido eliminado de esta encuesta.  
Pulsa Ir a encuestas para abrir la lista de encuestas.`,
  userRoleUpdatedRefreshRequired: `Tu rol en esta encuesta se ha actualizado.  
$t(common.pressRefreshToReloadPage)`,
  userGroup: {
    new: 'Nuevo grupo',
    edit: 'Editar grupo',
    name: 'Nombre',
    label: 'Etiqueta',
    qualifier: 'Calificador {{index}}',
    qualifier_plural: 'Calificadores',
    qualifierKey: 'Clave',
    qualifierValue: 'Valor',
    addQualifier: 'Añadir calificador',
    members: 'Miembros',
    addMember: 'Añadir miembro',
    noMembers: 'Aún no hay miembros',
    memberAlreadyInGroup: 'Actualmente en "{{groupName}}"',
    tabs: {
      groups: 'Grupos de usuarios',
      assignments: 'Asignación de grupos',
      report: 'Informe de miembros',
    },
    memberName: 'Nombre del miembro',
    memberEmail: 'Correo electrónico del miembro',
    memberRole: 'Rol en la encuesta',
    memberStatus: 'Estado',
    status: {
      INVITED: 'Invitado',
      ACCEPTED: 'Aceptado',
      FORCE_CHANGE_PASSWORD: 'Cambio de contraseña requerido',
    },
    unassigned: 'Sin asignar',
    confirmDelete: '¿Eliminar el grupo "{{name}}"? Sus miembros quedarán sin asignar. ¿Continuar?',
    deleteConfirmed: 'El grupo "{{name}}" ha sido eliminado',
    saveConfirmed: 'El grupo "{{name}}" ha sido guardado',
    confirmReassign: '{{userName}} está actualmente en el grupo "{{groupName}}". ¿Moverlo a este grupo en su lugar?',
    notFound: 'Grupo no encontrado',
  },
  updateUserConfirmation: 'El usuario {{name}} ha sido actualizado',
  userNotInvitedToAnySurvey: 'Usuario no invitado a ninguna encuesta',
  userSurveys: 'Encuestas de usuario',
  usersBackup: {
    menu: 'Copia de seguridad / Restaurar',
    backup: 'Copia de seguridad de usuarios',
    backupTitle: 'Copia de seguridad de usuarios',
    backupInfo:
      'Todos los usuarios se exportarán con sus roles en las encuestas y sus grupos de usuarios, para poder restaurarlos en otro servidor de Arena. Los dispositivos 2FA no se exportan.',
    includePasswords: 'Incluir contraseñas',
    passwordsWarning:
      'El archivo de copia de seguridad contendrá los hashes de las contraseñas: guárdelo en un lugar seguro y elimínelo después de usarlo.',
    restore: 'Restaurar usuarios',
    restoreTitle: 'Restaurar usuarios desde una copia de seguridad',
    restoreInfo: `- Los usuarios se identifican por su correo electrónico
- Los roles en las encuestas y los grupos de usuarios se identifican por el nombre de la encuesta y el nombre del grupo
- Los roles y grupos de usuarios de encuestas que no existen en este servidor se ignoran
- Después de pulsar "Restaurar usuarios", podrá elegir qué hacer con cada usuario`,
    backupFileInfo: 'Copia de seguridad generada por {{email}} el {{date}} (servidor: {{serverUrl}})',
    passwordsNotIncluded:
      'Las contraseñas no están incluidas en esta copia de seguridad: los usuarios nuevos tendrán que restablecer su contraseña',
    allNewUsers: 'Todos los usuarios nuevos ({{count}})',
    allExistingUsers: 'Todos los usuarios existentes ({{count}})',
    userStatus: 'Estado',
    userActionHeader: 'Acción',
    userNew: 'Nuevo',
    userExisting: 'Existente',
    userAction: {
      insert: 'Añadir',
      skip: 'Omitir',
      updateRoles: 'Actualizar roles en las encuestas',
      updateAll: 'Actualizar roles en las encuestas y datos',
    },
    sysAdmin: 'Admin. sist.',
    restorePassword: 'Contraseña',
    restorePasswordInfo:
      'Restaurar la contraseña guardada en la copia de seguridad (solo al añadir el usuario o actualizar sus datos)',
    userActionShort: {
      insert: 'Añadir',
      skip: 'Omitir',
      updateRoles: 'Roles',
      updateAll: 'Roles + datos',
    },
    details: {
      survey: 'Encuesta',
      roleInBackup: 'Rol en la copia de seguridad',
      currentRole: 'Rol actual',
      notFoundInThisServer: '(no encontrado en este servidor)',
      userGroup: 'Grupo de usuarios',
      inBackup: 'En la copia de seguridad',
      currentMember: 'Miembro actual',
    },
    summaryImported: 'Usuarios restaurados',
    summary: {
      usersTotal: 'Usuarios en la copia de seguridad: {{count}}',
      usersInserted: 'Usuarios nuevos: {{count}}',
      usersUpdated: 'Usuarios actualizados: {{count}}',
      usersSkipped: 'Usuarios omitidos: {{count}}',
      authGroupsAdded: 'Roles en encuestas añadidos: {{count}}',
      userGroupsAdded: 'Pertenencias a grupos de usuarios añadidas: {{count}}',
    },
    surveysNotFound: 'Encuestas no encontradas (roles ignorados): {{names}}',
    userGroupsNotFound: 'Grupos de usuarios no encontrados (pertenencias ignoradas): {{names}}',
  },
}
